import { isVenueProductExcludedFromGrossProfit } from './excludeFromGrossProfit'
import { getParLevelForProduct } from './parLevelPaywall'

const parseMonthlyLimit = value => {
  if (value === '' || value == null) {
    return null
  }

  const parsed = Number(value)
  return Number.isFinite(parsed) ? parsed : null
}

const toRefId = value => value?._id ?? value

const toOptionalString = (value, fallback = '') => {
  if (value == null) return fallback
  return String(value)
}

/** POST body aligned with server VenueProduct Joi validation (no table/UI extras). */
export const buildVenueProductSavePayload = (product, venueId) => ({
  _id: product._id,
  title: product.title,
  product: toRefId(product.product),
  // Persist ObjectIds only — populated conversion docs fail some save paths.
  conversions: Array.isArray(product.conversions)
    ? product.conversions.map(toRefId).filter(Boolean)
    : [],
  venue: venueId,
  supplier: toRefId(product.supplier),
  // Joi requires a string; Mongo defaults supplierTitle to null.
  supplierTitle: toOptionalString(product.supplierTitle, ''),
  nominalCode: product.nominalCode ?? '',
  UoM: product.UoM,
  zone: toOptionalString(product.zone, 'Default Zone'),
  secondaryZone: product.secondaryZone ?? '',
  defaultQuantity: Number(product.defaultQuantity) || 1,
  parLevel: getParLevelForProduct(product),
  excludeFromGrossProfit: isVenueProductExcludedFromGrossProfit(product),
  type: toOptionalString(product.type, 'Default Type'),
  monthlyLimit: parseMonthlyLimit(product.monthlyLimit),
  isFavourite: Boolean(product.isFavourite),
  isSpecialProduct: Boolean(product.isSpecialProduct),
  specialPrice: product.specialPrice,
  OMSSpecialPrice: product.OMSSpecialPrice,
  brakesPrice: product.brakesPrice,
  customImage: product.customImage?.keyName
    ? { keyName: product.customImage.keyName }
    : null,
})
